module.exports = __webpack_public_path__ + "media/images/landing-find-match-3-8476d03114ae33178113ca70925fd4e7.jpeg";